/**
 * Contract List Page - Display organization deal reports
 */
import React from 'react'

import { useTranslation } from 'react-i18next'

import {
  Flex,
  SideMenuLayoutBreadcrumb,
  SideMenuLayoutContentLayout,
  Stack,
} from '@enechain/ecloud-designsystem'

import { ContractListTable } from '~/pages/ContractList/components/ContractTable'
import { ExportButton } from '~/pages/ContractList/components/ExportButton'
import { ContractFilterSection } from '~/pages/ContractList/components/FilterSection/ContractFilterSection'
import { useContractListData } from '~/pages/ContractList/hooks/useContractListData'
import { useContractListFilter } from '~/pages/ContractList/hooks/useContractListFilter'

export const ContractListPage: React.FC = (): React.ReactElement => {
  const { t } = useTranslation(['page'])

  const breadcrumbItems = [
    { label: t('page:shared.contract_list'), bold: true },
  ]

  const { filter, updateFilter } = useContractListFilter()
  const { data, perFrameData, isLoading } = useContractListData(filter)

  return (
    <SideMenuLayoutContentLayout
      header={<SideMenuLayoutBreadcrumb items={breadcrumbItems} />}
    >
      <Stack gap="4">
        <ContractFilterSection
          filterState={filter}
          updateFilter={updateFilter}
        />
        <Flex justifyContent="flex-start">
          <ExportButton
            data={data}
            perFrameData={perFrameData}
            filterState={filter}
          />
        </Flex>
        <ContractListTable data={data} loading={isLoading} />
      </Stack>
    </SideMenuLayoutContentLayout>
  )
}
